import { LastViewedObject } from "../../types/types";
import Page from "../Page";
import PersonList from "../PersonList";
import useFetchPage from "../hooks/useFetchPage";

interface Props {
  setLastViewed: (value: LastViewedObject) => void;
}

const Committee = ({ setLastViewed }: Props) => {
  const page = useFetchPage(setLastViewed);

  return (
    page && (
      <Page title={page.frontmatter.title} description={page.content}>
        <PersonList isCommittee={true} />
      </Page>
    )
  );
};

export default Committee;
